import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Loader from "../components/loader";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Home from "../page/Home";
import WebDevlopment from "../page/WebDevlopment";
import Design from "../page/Design";
import VideoEditing from "../page/VideoEditing";
import Animation from "../page/Animation";
import NavigationBar from "../components/NavigationBar";
import Mockup from "../page/Mockup";
import Course from "../page/Course";
import AiTools from "../page/AiTools";
import More from "../page/More";
import Pegination from "../components/Pegination";
import Uxui from "../page/Uxui";
import LoginPage from "../page/LoginPage";
import Dashboard from "../page/Dashboard";
import CardAdd from "../components/CardAdd";
import CardEdit from "../components/CardEdit";
import axios from "axios";
import SpecialLink from "../page/SpecialLink";

// Admin Route Protection Function Start
function PrivateRoute({ element }) {
  const token = localStorage.getItem("jwtToken");
  const isAuthenticated = !!token;
  console.log(token);
  if (isAuthenticated) {
    return element;
  } else {
    return <Navigate to="/samieullahbaig" replace={true} />;
  }
}
// Admin Route Protection Function End

function Layout() {
  // Location From react-router-dom To Get The Page Route Start
  const location = useLocation();
  // Location From react-router-dom To Get The Page Route End

  // States Start
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [mixedData, setMixedData] = useState([]);
  // States End

  // Navigation On Mobile Screen Function Start
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3000);
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 899);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  // Navigation On Mobile Screen Function End

  // Fetching Data All Data Function Start
  useEffect(() => {
    axios
      .get("https://devuse-fullstack.vercel.app/tools/all-tools")
      .then((response) => {
        const combinedData = response.data;

        setMixedData(combinedData);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });

    const loadingTimer = setTimeout(() => {}, 3000);
    return () => clearTimeout(loadingTimer);
  }, []);
  // Fetching Data All Data Function Start

  // Rendering Loader Statement Start
  if (loading) {
    return <Loader />;
  }
  // Rendering Loader Statement End

  // Logic To Hide Sidebar Start
  const routesToHideComponents = [
    "/samieullahbaig",
    "/dashboard",
    "/add-tool",
    ...mixedData.map((item) => `/dashboard/tool/edit/${item._id}`),
  ];
  // Logic To Hide Sidebar End

  // Hiding Sidebar With Reference To Path Start
  const shouldHideComponents = routesToHideComponents.includes(
    location.pathname
  );

  return (
    <div className="layout">
      {!shouldHideComponents && <Navbar />}
      {isMobile && !shouldHideComponents && <Pegination />}
      {!shouldHideComponents && <NavigationBar />}
      <div className="side_layout postion-fixed">
        {!shouldHideComponents && <Sidebar />}
      </div>

      {/* Routes Start*/}

      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/web-development/tools" element={<WebDevlopment />} />
        <Route path="/design/tools" element={<Design />} />
        <Route path="/video-editing/tools" element={<VideoEditing />} />
        <Route path="/animation/tools" element={<Animation />} />
        <Route path="/mockup/tools" element={<Mockup />} />
        <Route path="/course/tools" element={<Course />} />
        <Route path="/AI/tools" element={<AiTools />} />
        <Route path="/secret-link/tools" element={<SpecialLink />} />
        <Route path="/more-tools/tools" element={<More />} />
        <Route path="/UX-UI/tools" element={<Uxui />} />
        <Route path="/samieullahbaig" element={<LoginPage />} />
        {/* Private Routes Start */}
        <Route
          path="/dashboard/*"
          element={<PrivateRoute element={<Dashboard />} />}
        />
        <Route
          path="/add-tool"
          element={<PrivateRoute element={<CardAdd />} />}
        />
        <Route
          path="/dashboard/tool/edit/:toolId"
          element={<PrivateRoute element={<CardEdit />} />}
        />
        {/* Private Routes End */}
      </Routes>
      {/* Routes End*/}
    </div>
  );
}

export default Layout;
